import { defineMessages } from 'react-intl';

/**
 * Copy for toasts fired from the non-React `legacyStreamResponseBody` handler.
 * The descriptors are rendered as `<FormattedMessage />` elements inside the
 * toast, so localization resolves in the Toaster (mounted under
 * `HeidiIntlProvider` in both the full app and minimal-providers trees).
 */
export const streamResponseMessages = defineMessages({
  templateUnavailableTitle: {
    defaultMessage: 'Template unavailable',
    id: 'YdCGZ5Kj11',
    description: 'Toast title when note generation is denied for the selected template',
  },
  templateUnavailableDescription: {
    defaultMessage:
      'You no longer have access to the selected template. Please choose another template and try again.',
    id: 'qzM8nXUEWq',
    description:
      'Toast body telling the clinician to pick a different template after a template access denial',
  },
  sectionalConversionFailedTitle: {
    defaultMessage: 'Sectional note could not be restored',
    id: 'F1Q6SB1u0W',
    description:
      'Toast title when the post-regeneration conversion back to a sectional note failed',
  },
  sectionalConversionFailedDescription: {
    defaultMessage:
      'The note is shown as an editable whole note for now. The next regeneration will try restoring the sectional format.',
    id: 'TzOnJRAog0',
    description:
      'Toast body telling the clinician the sectional note format was not restored and how to retry',
  },
  templateDeletedDescription: {
    defaultMessage:
      'The selected template has been deleted. Please choose another template and try again.',
    id: 'kXU68zHxVP',
    description:
      'Toast body telling the clinician to pick a different template after the selected one was deleted',
  },
});
